import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PageLayout } from '@/components/layout/PageLayout.js';
import { useAiChat } from '@/hooks/useAiChat.js';
import { NAV_LABELS } from '@/lib/nav-labels.js';
import { api } from '@/lib/api.js';

export function ChatAssistPage() {
  const me = useQuery({
    queryKey: ['me'],
    queryFn: async () => (await api.get('/auth/me')).data as { role: string },
  });
  const isMentor = ['MENTOR', 'GESTOR_MENTORIA', 'ADMIN', 'SUPER_ADMIN'].includes(me.data?.role ?? '');
  const [mentorMode, setMentorMode] = useState(false);
  const task = mentorMode && isMentor ? 'CHAT_MENTOR' : 'CHAT_ALUNO';
  const chat = useAiChat(task);

  return (
    <PageLayout
      title={NAV_LABELS.hackIa}
      description={
        mentorMode
          ? 'Modo preparação de sessão — análise de diagnósticos do mentorado.'
          : 'Pergunte sobre o método ou seu diagnóstico (corpus Hack Academy).'
      }
      className="flex h-[calc(100vh-10rem)] flex-col"
      actions={
        isMentor ? (
          <button
            type="button"
            className={`rounded-element border px-3 py-1 text-[10px] font-bold uppercase ${
              mentorMode ? 'border-accent text-accent' : 'border-ha-border2 text-ha-muted'
            }`}
            onClick={() => setMentorMode((v) => !v)}
          >
            {mentorMode ? 'Modo mentor' : 'Modo aluno'}
          </button>
        ) : undefined
      }
    >
      <div className="flex min-h-0 flex-1 flex-col rounded-card border border-ha-border2 bg-ha-card">
        <div className="flex-1 overflow-y-auto p-4">
          {chat.messages.length === 0 && (
            <p className="text-sm text-ha-muted">
              {mentorMode
                ? 'Descreva o mentorado ou peça pontos de atenção com base nos diagnósticos.'
                : 'Pergunte sobre o método ou seu diagnóstico.'}
            </p>
          )}
          {chat.messages.map((m, i) => (
            <p
              key={i}
              className={`mb-3 text-sm ${m.role === 'user' ? 'text-ha-text' : 'text-ha-subtle'}`}
            >
              <strong>{m.role === 'user' ? 'Você' : 'Hack Growth IA'}:</strong> {m.content}
            </p>
          ))}
          {chat.send.isPending && (
            <p className="text-sm text-ha-muted animate-pulse">Hack Growth IA está a pensar…</p>
          )}
          {chat.error && <p className="text-sm text-feedback">{chat.error}</p>}
        </div>
        <form
          className="flex gap-2 border-t border-ha-border2 p-4"
          onSubmit={(e) => {
            e.preventDefault();
            chat.submit();
          }}
        >
          <input
            className="flex-1 rounded-element border border-ha-border2 bg-ha-card2 px-3 py-2 text-sm"
            value={chat.input}
            onChange={(e) => chat.setInput(e.target.value)}
            placeholder="Sua pergunta…"
            disabled={chat.send.isPending}
          />
          <button
            type="submit"
            className="rounded-element px-4 py-2 text-xs font-bold uppercase text-black disabled:opacity-50"
            style={{ background: '#ffc800' }}
            disabled={chat.send.isPending}
          >
            Enviar
          </button>
        </form>
      </div>
    </PageLayout>
  );
}
